import React from 'react';

import Box from 'components/Box';
import { PrimaryButton, SecondaryButton } from 'components/Button';
import { BodySmall } from 'components/Text';

// TODO: Fix this the next time the file is edited.
// eslint-disable-next-line react/function-component-definition
const IdealistDaysMapConvertPinToEventConfirm = ({
  mapType,
  confirmConvertPin,
  cancelConvertPin,
}: {
  mapType: string;
  confirmConvertPin: () => void;
  cancelConvertPin: () => void;
}) => (
  <>
    <BodySmall mb={16}>
      {getText('Would you like other people to join you?')}
    </BodySmall>
    <Box display="flex">
      <PrimaryButton
        data-qa-id="days-map-convert-confirm-add"
        size="small"
        onClick={confirmConvertPin}
        mr={2}
      >
        {mapType === 'DAYS'
          ? getText('Yes, create event')
          : getText('Yes, create group')}
      </PrimaryButton>
      <SecondaryButton
        data-qa-id="days-map-convert-confirm-cancel"
        size="small"
        onClick={cancelConvertPin}
      >
        {getText('No, I am good')}
      </SecondaryButton>
    </Box>
  </>
);

export default IdealistDaysMapConvertPinToEventConfirm;
